import React, { useRef, useState } from "react";
import { Modal, Table } from "react-bootstrap";
import ReactToPrint from "react-to-print";
import MultiStudentFeeChallan from "../MultiStudentFeeChallan/MultiStudentFeeChallan";

function CRMConversionSuccessModal({
  show,
  close,
  selectedStudent,
  registrationId,
  printData,
  unitName,
  icon,
}) {
  const componentRef = useRef(null);
  // const [blankPage, setBlankPage] = useState(false);
  // const student = Array.isArray(selectedStudent)
  //   ? selectedStudent[0]
  //   : selectedStudent;
  // const feeChallans = Array.isArray(student?.fee_challans)
  //   ? student.fee_challans
  //   : [];

  // const displayValue = (value) =>
  //   value === null || value === undefined || value === "" ? "---" : value;

  // const getChallanStatus = (status) => {
  //   switch (Number(status)) {
  //     case 0:
  //       return "Unpaid";
  //     case 1:
  //       return "Paid";
  //     case 2:
  //       return "Partially Paid";
  //     default:
  //       return "---";
  //   }
  // };

  // const pageStyle = `
  //   @page {
  //     size: letter landscape !important;
  //   }
  // `;
  const formatdate2 = () => {
    const date = new Date();

    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear();

    const formattedDate = `${day}/${month}/${year}`;

    return formattedDate;
  };

  const pageStyle = `
  @page {
    size: a4 !important;
}
`;
  return (
    <>
      <Modal show={show} onHide={close} centered size="lg">
        <Modal.Header className="modal_header_style" closeButton>
          <Modal.Title className="Modal_Heading_font">
            {printData ? "Inquiry Registration Slip" : "Congratulations"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!printData ? (
            <p className="text-center mb-5" style={{ fontSize: "16px" }}>
              The student has been converted successfully.
              <br />
              The assigned registration ID is{" "}
              {/* <b>{displayValue(student?.registration_id || registrationId)}</b>. */}
            </p>
          ) : (
            <>
              <div className="card mt-2">
                <h2 className="mb-8">Student Registration Details</h2>
                <div className=" col-md-12 d-flex ">
                  <div className=" col-md-6 d-flex ">
                    <div>
                      {" "}
                      <h5 style={{ color: "grey" }}>Name : &ensp;</h5>{" "}
                    </div>
                    <div>
                      <h5
                        title={
                          selectedStudent.student_name == undefined
                            ? null
                            : selectedStudent.student_name.length > 20
                            ? selectedStudent.student_name
                            : null
                        }
                        style={{
                          color: "grey",
                          textAlign: "start",
                          cursor: "pointer",
                        }}
                      >
                        {" "}
                        {selectedStudent.student_name == undefined
                          ? null
                          : " " + selectedStudent.student_name}
                      </h5>
                    </div>
                  </div>
                  <div className=" col-md-6 d-flex ">
                    <div>
                      {" "}
                      <h5 style={{ color: "grey" }}>
                        Father Name : &ensp;
                      </h5>{" "}
                    </div>
                    <div>
                      <h5
                        title={
                          selectedStudent.father_name == undefined
                            ? null
                            : selectedStudent.father_name.length > 15
                            ? selectedStudent.father_name
                            : null
                        }
                        style={{
                          color: "grey",
                          textAlign: "start",
                          cursor: "pointer",
                        }}
                      >
                        {" "}
                        {selectedStudent.father_name == undefined
                          ? null
                          : " " + selectedStudent.father_name}
                      </h5>
                    </div>
                  </div>
                </div>
                <hr />

                <div className=" col-md-12 d-flex ">
                  <div className=" col-md-6 d-flex ">
                    <div>
                      {" "}
                      <h5 style={{ color: "grey" }}>
                        Date of Birth : &ensp;
                      </h5>{" "}
                    </div>
                    <div>
                      <h5
                        title={
                          selectedStudent.date_of_birth == undefined
                            ? null
                            : selectedStudent.date_of_birth.length > 15
                            ? selectedStudent.date_of_birth
                            : null
                        }
                        style={{
                          color: "grey",
                          textAlign: "start",
                          cursor: "pointer",
                        }}
                      >
                        {" "}
                        {selectedStudent.date_of_birth == undefined
                          ? " " + "---" 
                          : " " + selectedStudent.date_of_birth}
                      </h5>
                    </div>
                  </div>
                  <div className=" col-md-6 d-flex ">
                    <div>
                      {" "}
                      <h5 style={{ color: "grey" }}>
                        <>Inquiry No. : &ensp;</>
                      </h5>
                    </div>
                    <div>
                      <h5
                        title={
                          selectedStudent.inquiry_no == undefined ||
                          selectedStudent.inquiry_no == null
                            ? "---"
                            : selectedStudent.inquiry_no
                        }
                        style={{
                          color: "grey",
                          textAlign: "start",
                          cursor: "pointer",
                        }}
                      >
                        {" "}
                        {selectedStudent.inquiry_no == undefined ||
                        selectedStudent.inquiry_no == null
                          ? " " + "---"
                          : " " + selectedStudent.inquiry_no}
                      </h5>
                    </div>
                  </div>
                </div>

                <hr />

                <div className=" col-md-12 d-flex ">
                  <div className=" col-md-6 d-flex ">
                    <div>
                      {" "}
                      <h5 style={{ color: "grey" }}>Gender : &ensp;</h5>{" "}
                    </div>
                    <div>
                      <h5
                        title={
                          selectedStudent.gender == undefined
                            ? null
                            : selectedStudent.gender.length > 15
                            ? selectedStudent.gender
                            : null
                        }
                        style={{
                          color: "grey",
                          textAlign: "start",
                          cursor: "pointer",
                        }}
                      >
                        {" "}
                        {selectedStudent.gender == undefined
                          ? " " + "---" 
                          : selectedStudent.gender.length > 15
                          ? " " +
                            selectedStudent.gender.substring(0, 12) +
                            "..."
                          : " " + selectedStudent.gender}
                      </h5>
                    </div>
                  </div>
                  <div className=" col-md-6 d-flex ">
                    <div>
                      {" "}
                      <h5 style={{ color: "grey" }}>
                        Mobile No# : &ensp;
                      </h5>{" "}
                    </div>
                    <div>
                      <h5
                        title={
                          selectedStudent.mobile_no == undefined
                            ? null
                            : selectedStudent.mobile_no.length > 15
                            ? selectedStudent.mobile_no
                            : null
                        }
                        style={{
                          color: "grey",
                          textAlign: "start",
                          cursor: "pointer",
                        }}
                      >
                        {" "}
                        {selectedStudent.mobile_no == undefined
                          ? null
                          : " " + selectedStudent.mobile_no}
                      </h5>
                    </div>
                  </div>
                </div>

                <hr />
                <div className=" col-md-12 d-flex ">
                  <div className=" col-md-6 d-flex ">
                    <div>
                      {" "}
                      <h5 style={{ color: "grey" }}>Campus: &ensp;</h5>{" "}
                    </div>
                    <div>
                      <h5
                        title={
                          selectedStudent?.campus?.name == undefined
                            ? null
                            : selectedStudent?.campus?.name.length > 15
                            ? selectedStudent?.campus?.name
                            : null
                        }
                        style={{
                          color: "grey",
                          textAlign: "start",
                          cursor: "pointer",
                        }}
                      >
                        {" "}
                        {selectedStudent?.campus == undefined
                          ? " " + "---"
                          : " " + selectedStudent?.campus?.name}
                      </h5>
                    </div>
                  </div>
                  <div className=" col-md-6 d-flex ">
                    <div>
                      {" "}
                      <h5 style={{ color: "grey" }}>Class : &ensp;</h5>{" "}
                    </div>
                    <div>
                      <h5
                        title={
                          selectedStudent.class == undefined
                            ? null
                            : selectedStudent.class?.name.length > 15
                            ? selectedStudent.class?.name
                            : null
                        }
                        style={{
                          color: "grey",
                          textAlign: "start",
                          cursor: "pointer",
                        }}
                      >
                        {" "}
                        {selectedStudent.class == undefined
                          ? " " + "---" 
                          : " " + selectedStudent.class?.name}
                      </h5>
                    </div>
                  </div>
                </div>

                <hr />
                <div className="row mx-3">
                  <div className="col-md-12">
                    <h5 style={{ color: "grey" }}>
                      <b>Address:</b> &ensp;
                    </h5>{" "}
                  </div>
                  <div className="col-md-12">
                    {/* <h5>{studentdetails.name}</h5> */}
                    <h5
                      title={
                        selectedStudent.address == undefined
                          ? null
                          : selectedStudent.address
                      }
                      style={{
                        color: "grey",
                        textAlign: "start",
                        cursor: "pointer",
                      }}
                    >
                      {" "}
                      {selectedStudent.address == undefined
                        ? " " + "---" 
                        : selectedStudent.address}
                    </h5>
                  </div>
                </div>
              </div>
              {/* <div className="row">
                <div className="col-md-6 mb-3">
                  <b>Student Name:</b> {displayValue(student?.name)}
                </div>
                <div className="col-md-6 mb-3">
                  <b>Father Name:</b> {displayValue(student?.father_name)}
                </div>
                <div className="col-md-6 mb-3">
                  <b>Admission ID:</b> {displayValue(student?.admission_id)}
                </div>
                <div className="col-md-6 mb-3">
                  <b>Registration ID:</b>{" "}
                  {displayValue(student?.registration_id || registrationId)}
                </div>
                <div className="col-md-6 mb-3">
                  <b>Campus:</b>{" "}
                  {displayValue(student?.campus_name || student?.campus?.name)}
                </div>
                <div className="col-md-6 mb-3">
                  <b>Class / Section:</b>{" "}
                  {displayValue(
                    [
                      student?.student_class_name ||
                        student?.student_class?.name,
                      student?.global_section_name ||
                        student?.global_section?.name,
                    ]
                      .filter(Boolean)
                      .join(" - "),
                  )}
                </div>
                <div className="col-md-6 mb-3">
                  <b>Mobile No:</b> {displayValue(student?.mobile_no)}
                </div>
                <div className="col-md-6 mb-3">
                  <b>Joining Date:</b> {displayValue(student?.Joining_date)}
                </div>
              </div>

              <h6 className="mt-3">Fee Challans</h6>
              {feeChallans.length > 0 ? (
                <div className="table-responsive">
                  <Table bordered size="sm" className="mb-0 text-center">
                    <thead>
                      <tr>
                        <th>Challan No.</th>
                        <th>Issue Date</th>
                        <th>Due Date</th>
                        <th>Payable</th>
                        <th>Paid</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {feeChallans.map((challan) => (
                        <tr key={challan.id || challan.challan_no}>
                          <td>{displayValue(challan.challan_no)}</td>
                          <td>{displayValue(challan.issue_date)}</td>
                          <td>{displayValue(challan.due_date)}</td>
                          <td>{displayValue(challan.payable)}</td>
                          <td>{displayValue(challan.paid)}</td>
                          <td>{getChallanStatus(challan.status)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              ) : (
                <p className="text-muted mb-0">No fee challan is available.</p>
              )} */}
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          {/* <div className="mr-4">
            <label className="checkbox checkbox-single mb-0">
              <input
                type="checkbox"
                checked={blankPage}
                onChange={(event) => setBlankPage(event.target.checked)}
              />
              <span />
              &nbsp;&nbsp;&nbsp;Use Blank Page For Print
            </label>
          </div> */}

          <ReactToPrint
            documentTitle="Fee Challan Print"
            pageStyle={pageStyle}
            removeAfterPrint
            trigger={() => (
              <button type="button" className="btn btn-primary w-80px">
                Print
              </button>
            )}
            content={() => componentRef.current}
          />

          <button type="button" className="btn btn-danger" onClick={close}>
            Close
          </button>
        </Modal.Footer>
      </Modal>

      <div
        ref={componentRef}
        id="printSection"
        style={{ visibility: "hidden" }}
      >
        {/* <MultiStudentFeeChallan
          allstudentList={selectedStudent}
          blankPage={blankPage}
        /> */}
        {selectedStudent ? (
          <>
            <div className="p-3" style={{ display: "flex" }}>
              <img style={{ height: 100, width: 110 }} src={icon} alt="icon"/>

              <div className="col-md-6 ml-4" style={{ paddingTop: "10px" }}>
                <h1>{unitName}</h1>
                <h4>
                  INQUIRY REGISTRATION SLIP FOR THE ACADEMIC SESSION{" "}
                  {selectedStudent?.session?.year}
                </h4>
                <h4>Printing Date:- {formatdate2()}</h4>
              </div>
            </div>
            <hr style={{ border: "2px solid prrimary" }} />

            <div
              className="d-flex justify-content-between p-5"
              style={{ border: `2px solid black` }}
            >
              <div>
                <div className="d-flex">
                  <h5 style={{ fontSize: "18px" }}>Inquiry No:-</h5>{" "}
                  &nbsp;&nbsp;{" "}
                  <h6 style={{ marginLeft: "182px", fontSize: "16px" }}>
                    {selectedStudent?.inquiry_no}
                  </h6>
                </div>
                <div className="d-flex">
                  <h5 style={{ fontSize: "18px" }}>Student Name:-</h5>{" "}
                  &nbsp;&nbsp;{" "}
                  <h6 style={{ marginLeft: "144px", fontSize: "16px" }}>
                    {selectedStudent?.student_name}
                  </h6>
                </div>
                <div className="d-flex">
                  <h5 style={{ fontSize: "18px" }}>Father Name:-</h5>{" "}
                  &nbsp;&nbsp;{" "}
                  <h6 style={{ marginLeft: "156px", fontSize: "16px" }}>
                    {selectedStudent?.father_name}
                  </h6>
                </div>
                <div className="d-flex">
                  <h5 style={{ fontSize: "18px" }}>Contact No.:-</h5>{" "}
                  &nbsp;&nbsp;{" "}
                  <h6 style={{ marginLeft: "166px", fontSize: "16px" }}>
                    {selectedStudent?.mobile_no}
                  </h6>
                </div>
                <div className="d-flex">
                  <h5 style={{ fontSize: "18px" }}>Class Name:-</h5>{" "}
                  &nbsp;&nbsp;{" "}
                  <h6 style={{ marginLeft: "166px", fontSize: "16px" }}>
                    {selectedStudent?.class?.name}
                  </h6>
                </div>
                <div className="d-flex">
                  <h5 style={{ fontSize: "18px" }}>Campus Name:-</h5>{" "}
                  &nbsp;&nbsp;{" "}
                  <h6 style={{ marginLeft: "137px", fontSize: "16px" }}>
                    {selectedStudent?.campus?.name}
                  </h6>
                </div>
                <div className="d-flex">
                  <h5 style={{ fontSize: "18px" }}>Address :-</h5>{" "}
                  &nbsp;&nbsp;{" "}
                  <h6 style={{ marginLeft: "195px", fontSize: "16px" }}>
                    {selectedStudent?.address}
                  </h6>
                </div>
              </div>
              {/* <div style={{ marginTop: "65px", marginRight: "50px" }}>
                <span className="">
                  <p
                    style={{
                      border: "1px solid #121291",
                      fontSize: "20px",
                      fontFamily: "cursive",
                    }}
                    className="p-5"
                  >
                    CONGRATULATIONS
                  </p>
                </span>
              </div> */}
            </div>
          </>
        ) : null}
      </div>
    </>
  );
}

export default CRMConversionSuccessModal;
